/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { cdnBaseUrl, environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

const isConnectedAppsRoute = /^\/connected-apps(?:\/|$)/.test(window.location.pathname);

if (!isConnectedAppsRoute && environment.sentryDsn) {
    Sentry.init({
        dsn: environment.sentryDsn,
        environment: environment.environment,
        tracesSampleRate: 1,
        release: environment.sentryRelease,
        ignoreErrors: ['[@ant-design/icons-angular]'],
        integrations: [Sentry.browserTracingIntegration()],
        tracePropagationTargets: [new URL(environment.myLabBaseUrl).origin],
    });
}

if (environment.production) {
    enableProdMode();
}

const createTagManagerSession = (settings: { trackingId: string}) => {
    const script = document.createElement('script');

    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${settings.trackingId}');`;

    const body = document.getElementsByTagName('body');
    body[0].appendChild(script);
};

if (!isConnectedAppsRoute && environment.googleTagManager != null && environment.googleTagManager.trackingId != null) {
    createTagManagerSession(environment.googleTagManager);
}

// Check if the page is in an iframe and redirect if necessary
if (top.location !== location) {
    top.location.href = document.location.href;
} else {
    platformBrowserDynamic().bootstrapModule(AppModule);
}
